import { castGroups } from '@/mocks/chigua';

const dotColor = ['bg-accent-500', 'bg-ocher-300', 'bg-ink-500', 'bg-accent-200'];

export default function Cast() {
  return (
    <section id="cast" className="scroll-mt-16 bg-paper-100/70 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="font-heading text-sm font-bold tracking-widest text-accent-700">人物关系 · 网络拆解</span>
              <span className="h-px w-8 bg-accent-400" />
            </div>
            <h2 className="mt-2 font-heading text-2xl font-bold text-ink-900 md:text-3xl">
              谁站在聚光灯下，谁藏在镜头之外
            </h2>
          </div>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-ink-500">
            <span className="flex items-center gap-1.5"><span className="inline-block h-2 w-2 rounded-full bg-accent-500" /> 台前</span>
            <span className="flex items-center gap-1.5"><span className="inline-block h-2 w-2 rounded-full bg-ocher-300" /> 间接</span>
            <span className="flex items-center gap-1.5"><span className="inline-block h-2 w-2 rounded-full bg-ink-500" /> 幕后</span>
            <span className="flex items-center gap-1.5"><span className="inline-block h-2 w-2 rounded-full bg-accent-200" /> 围观</span>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {castGroups.map((g, i) => (
            <div key={g.name} className="flex flex-col rounded-lg border border-paper-200 bg-paper-50 p-5">
              <div className="flex items-center justify-between">
                <span className={`h-2.5 w-2.5 rounded-full ${dotColor[i % dotColor.length]}`} />
                <span className="text-xs text-ink-400">{g.count}</span>
              </div>
              <h3 className="mt-3 font-heading text-lg font-bold text-ink-900">{g.name}</h3>
              <p className="mt-1 text-xs leading-relaxed text-ink-500">{g.role}</p>

              <ul className="mt-4 space-y-2">
                {g.members.map((m) => (
                  <li
                    key={m}
                    className="flex items-center gap-2 rounded-md bg-paper-100 px-3 py-2 text-[13px] text-ink-700"
                  >
                    <i className="ri-user-line text-xs text-accent-500" />
                    {m}
                  </li>
                ))}
              </ul>

              <p className="mt-4 flex-1 border-t border-paper-200 pt-3 text-[12px] leading-[1.7] text-ink-500">
                <i className="ri-pushpin-2-line mr-1 text-accent-500" />
                {g.note}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}